import { AUTH_URL } from './constantes';

export const redirectToLogin = () => {
    const redirect = encodeURIComponent(window.location.href);
    window.location.href = `${AUTH_URL}/login?redirect=${redirect}`;
};

export async function authFetch(url, options = {}) {
    const res = await fetch(url, { ...options, credentials: 'include' });
    if (res.status === 401) {
        redirectToLogin();
        return res;
    }
    return res;
}
